// Localização: frontend/src/hooks/data/useHistoricoSinaisVitais.js (versão 0.2.1)

import { useState, useEffect } from 'react';
// 💡 Importar a função específica de API
import { getHistoricoSinaisVitais as fetchHistoricoApi } from '../../api/api'; 
// Usamos um alias 'fetchHistoricoApi' para evitar conflito de nomes se o hook for chamado 'getHistoricoSinaisVitais'

/**
 * @function useHistoricoSinaisVitais
 * @description Hook customizado para buscar o histórico de Sinais Vitais de um paciente.
 * @param {number} pacienteId - O ID do paciente.
 * @returns {{historicoSV: Array, isLoading: boolean, error: string | null}}
 */
export const useHistoricoSinaisVitais = (pacienteId) => {
    const [historicoSV, setHistoricoSV] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Se o ID do paciente for inválido ou zero, não faz a chamada.
        if (!pacienteId) {
            setIsLoading(false);
            return;
        }

        const fetchHistoricoSV = async () => {
            setIsLoading(true);
            setError(null);
            try {
                // 🎯 Chama a função de API atualizada
                const response = await fetchHistoricoApi(pacienteId);
                
                // O backend retorna: { message: "...", data: [...] }
                setHistoricoSV(response.data.data); 
            } catch (err) {
                console.error("Falha ao buscar histórico de Sinais Vitais:", err.response ? err.response.data : err.message);
                
                let errorMessage = "Erro ao carregar o histórico de Sinais Vitais.";
                if (err.response && err.response.data && err.response.data.message) {
                    errorMessage = err.response.data.message;
                }
                
                setError(errorMessage);
                setHistoricoSV([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchHistoricoSV();
        
        // Dependência: O hook reexecuta quando o pacienteId muda.
    }, [pacienteId]);

    return { historicoSV, isLoading, error };
};